/* ==========================================================================
   PWR HERO
   The ONLY behaviour the PWR Animation Engine does not already provide:
   pointer-driven parallax (subtle mouse-follow on the hero art + light).

   Everything else is reused, NOT reimplemented:
     - Fade / staggered reveal  -> engine's [data-pwr-reveal] / -group
     - Float                    -> Design System .pwr-float keyframe
     - Scroll parallax          -> engine's [data-pwr-parallax]
     - Reduced motion, raf throttle, section lifecycle -> JS Core / utils

   This controller registers through PWR.registerSection (Theme Editor safe,
   no duplicate init). It sets CSS custom properties (--pwr-hero-mx/-my) that
   pwr-hero.css consumes with transform; JS never touches layout directly.
   Disabled under prefers-reduced-motion, on touch/coarse pointers, and on
   mobile. No new scroll listener — pointermove only, rAF-coalesced.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.PWR || !window.PWR.registerSection) return;
  var PWR = window.PWR;
  var utils = PWR.utils;
  var Section = PWR.Section;

  function Hero(root) {
    Section.call(this, root);
  }
  Hero.prototype = Object.create(Section.prototype);
  Hero.prototype.constructor = Hero;

  Hero.prototype.init = function () {
    // Opt-out entirely if the merchant disabled motion parallax, or the
    // environment can't/shouldn't run it.
    if (this.root.getAttribute('data-pwr-hero-parallax') !== 'true') return;
    if (utils.prefersReducedMotion()) return;
    if (!utils.supportsHover()) return;      // touch / coarse pointer -> skip
    if (utils.isMobile()) return;

    this.stage = this.$('[data-pwr-hero-stage]') || this.root;
    this._targets = this.$$('[data-pwr-hero-depth]');
    if (!this._targets.length) return;

    this._onMove = utils.rafThrottle(this._handleMove.bind(this));
    this._onLeave = this._reset.bind(this);

    this.stage.addEventListener('pointermove', this._onMove);
    this.stage.addEventListener('pointerleave', this._onLeave);
    this.addCleanup((function (self) {
      return function () {
        self.stage.removeEventListener('pointermove', self._onMove);
        self.stage.removeEventListener('pointerleave', self._onLeave);
      };
    })(this));

    // If reduced-motion is toggled on mid-session, stop and reset.
    var self = this;
    this._motionUnsub = PWR.bus.on(PWR.EVENTS.reducedMotionChange, function (m) {
      if (m.reducedMotion) {
        self.stage.removeEventListener('pointermove', self._onMove);
        self._reset();
      }
    });
    this.addCleanup(function () { if (self._motionUnsub) self._motionUnsub(); });
  };

  Hero.prototype._handleMove = function (event) {
    var rect = this.stage.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    // Normalised -0.5..0.5 around the stage centre.
    var nx = (event.clientX - rect.left) / rect.width - 0.5;
    var ny = (event.clientY - rect.top) / rect.height - 0.5;

    for (var i = 0; i < this._targets.length; i++) {
      var el = this._targets[i];
      // Per-element depth multiplier (px of travel), default subtle.
      var depth = parseFloat(el.getAttribute('data-pwr-hero-depth')) || 12;
      el.style.setProperty('--pwr-hero-mx', (nx * depth).toFixed(2) + 'px');
      el.style.setProperty('--pwr-hero-my', (ny * depth).toFixed(2) + 'px');
    }
  };

  Hero.prototype._reset = function () {
    for (var i = 0; i < this._targets.length; i++) {
      this._targets[i].style.setProperty('--pwr-hero-mx', '0px');
      this._targets[i].style.setProperty('--pwr-hero-my', '0px');
    }
  };

  Hero.prototype.destroy = function () {
    this._reset && this._targets && this._reset();
    Section.prototype.destroy.call(this);
  };

  PWR.registerSection('pwr-hero', function (root) { return new Hero(root); });
})();
